import React            from 'react';
import CamShowsHeader   from './CamShowsHeader';
import CamShowsGrid     from './CamShowsGrid';
import Flux             from '../../flux/Flux';
import Translations     from '../../utils/Translations';
import CamShowsFAQ      from './CamShowsFAQ';
import LogoLoader                from "../Loader/LogoLoader";

function getTranslation(text, ...args) {
  return Translations.get(`cam_shows.${text}`, ...args);
}
class CamShows extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      featuredShows:      [],
      shows:              [],
      isMobileBreakpoint: this.isMobileBreakpoint(),
      isLoading:          true,
    };

      this.loadCamShows       = this.loadCamShows.bind(this);
      this.onWindowResize     = this.onWindowResize.bind(this);
      this.onCloseModal       = this.onCloseModal.bind(this);
      this.onChatTicketChange = this.onChatTicketChange.bind(this);
  }

  componentDidMount() {
    this.loadCamShows();
    Flux.Browser.addWindowResizeListener(this.onWindowResize);
    Flux.NewMessenger.addChatTicketChangeListener(this.onChatTicketChange);
  }

  componentWillUnmount() {
    Flux.Browser.removeWindowResizeListener(this.onWindowResize);
    Flux.NewMessenger.removeChatTicketChangeListener(this.onChatTicketChange);
  }

  onChatTicketChange() {
    this.loadCamShows();
  }

  onWindowResize() {
    const isMobileBreakpoint = this.isMobileBreakpoint();
    this.setState({isMobileBreakpoint});
  }

  isMobileBreakpoint() {
    return window.innerWidth < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm;
  }

  onCloseModal() {
    this.loadCamShows();
  }

  loadCamShows() {
    const now         = new Date();
    now.setMinutes(0,0,0);
    const endDateFrom = now.toISOString();
    const dateTo      = new Date();
    dateTo.setDate(now.getDate() + 8 * 7);
    dateTo.setHours(23, 59, 59, 999);
    const startDateTo = dateTo.toISOString();
    const order       = 'ASC';

    const queryString  = window.location.search;
    const urlParams    = new URLSearchParams(queryString);
    const showInternal = urlParams.get('internal') === '1';

    Flux.Vxql.getCamShows({endDateFrom, order, startDateTo, first: null, internal: showInternal, callback: (data) => {
        const list = data.data.chatShows.getShowList;
       if (list.total) {
         const counter = [];
         let filteredShows   = list.shows.filter(item => item); //filter null
         if(!showInternal){
          filteredShows = filteredShows.filter(item => !item.isInternal); //exlude internals
         }
         filteredShows       = filteredShows.map(show => { // because of multiple shows per model, every ticket shoudl have a different cover image. therefore add occurence to define sedcards index
          counter.push(show.actorId);
           return {...show, count: filteredShows.filter(item => item.actorId === show.actorId).length, occurence: (counter.filter(item => item === show.actorId).length - 1) % filteredShows.filter(item => item.actorId === show.actorId).length};
          });
         const featuredShows = filteredShows.filter(item => item.isFeatured || item.isAutoFeatured);
         this.setState({featuredShows, shows: filteredShows, isLoading: false});
       }
    }});
  }

  render() {
    if (this.state.isLoading) {
      return <div className='cam-shows cam-shows--full-height'><div className="logo-loader__overlay"><LogoLoader pulse={true} /></div></div>;
    }
    return (
      <div className='cam-shows'>
        <div className='cam-shows__bg-wrapper'>
          {!this.state.isMobileBreakpoint && <img className="cam-shows__bg-header" src="/assets/img/camshows/header.jpg" alt="" />}
          {!this.state.isMobileBreakpoint && <div className="cam-shows__bg-repeat"> </div>}
          {this.state.isMobileBreakpoint && <img className="cam-shows__bg-header" src="/assets/img/camshows/bg_mobile.jpg" alt="" />}
          {this.state.isMobileBreakpoint && <div className="cam-shows__bg-repeat"> </div>}
        </div>
        <CamShowsHeader getTranslation={getTranslation} featuredShows={this.state.featuredShows} isMobile={this.state.isMobileBreakpoint} onCloseModal={this.onCloseModal} />
        {this.state.shows.length > 0 && <div className='cam-shows__grid-wrapper'>
          <h2 className='cam-shows__grid-title'>{getTranslation('grid-title')}</h2>
          <CamShowsGrid items={this.state.shows} onCloseModal={this.onCloseModal} />
        </div>}
        <CamShowsFAQ />
      </div>
    );
  }
}

export default CamShows;

export {getTranslation};
